export default {
  titlePage: 'آدرس دانش آموزان',
  search: 'جستجو ...',
  id: 'شناسه',
  phone: 'تلفن گیرنده',
  country: 'کشور',
  province: 'استان',
  city: 'شهر',
  title: 'عنوان',
  StudentName: 'نام دانش آموز',
  loading: 'در حال دریافت اطلاعات ...',
  operating: 'عملیات',
  empty: 'داده ای یافت نشد',
  success: 'موفق',
  deleteConfirm: 'آیا از حذف این کاربر مطمئن هستید؟',

  back: 'لغو',
  error: 'خطا',
  save: 'ذخیره',
  saving: 'در حال بارگزاری ...',
  next: 'بعدی',
  previous: 'قبلی',

  address: 'آدرس',
  details: 'جزيیات',
  postalCode: 'کد پستی',
  placeholderPhone: 'شماره تلفن را وارد نماید',
  placeholderTitle: 'عنوان را وارد نماید',
  placeholderAddress: 'آدرس را وارد نماید',
  placeholderDetails: 'جزيیات ادرس را وارد نماید',
  placeholderPostalCode: 'کد پستی را وارد نماید',


}
